import { ChangeDetectionStrategy, Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PolicyService, PolicyData } from '../services/policy.service';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['../landing-page/landing-page.component.css', './terms-and-conditions.component.css'],
  standalone: true,
  imports: [CommonModule, RouterModule, MatProgressSpinnerModule]
})
export class TermsAndConditionsComponent implements OnInit {
  isLoginDropdownOpen = false;
  policyData: PolicyData | null = null;
  isLoading = true;

  constructor(
    private router: Router,
    private policyService: PolicyService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.policyService.getPolicy('terms').subscribe(data => {
      this.policyData = data;
      this.isLoading = false;
      this.cdr.markForCheck();
    });
  }

  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleLoginDropdown(): void {
    this.isLoginDropdownOpen = !this.isLoginDropdownOpen;
  }

  adminportal(): void {
    this.router.navigate(['/account/login']);
  }

  candidateportal(): void {
    this.router.navigate(['/candidate']);
  }

  navigateToContactUs(): void {
    this.router.navigate(['/contact-us']);
  }
}
